/**
 * Slugify a category/qualification display name (e.g. "Aerobatic Flight")
 * into the kebab-case form used by the corresponding asset filename
 * (logo_aerobatic-flight.svg). Category/qualification logo filenames used to
 * be saved with the raw display name (spaces included), which some crawlers
 * and CDNs mishandle (SEO audit ticket C9). Filenames were slugified; this
 * helper keeps the runtime `require()` lookup in sync with the new names.
 */
export function slugifyAssetName(name) {
  return (name || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
}
